<ul class="field-review-list" test-id="fieldReviewList">
  <li *ngFor="let row of rows; trackBy: trackByToken"
      [attr.test-id]="'fieldReviewRow-' + row.token"
      [class.is-unselected]="row.fields.length && !row.selected"
      [ngClass]="'field-review-row--' + statusClass(row)"
      class="field-review-row">
    <div class="field-review-row-header">
      <label *ngIf="row.fields.length" class="checkbox m-b-0">
        <input (change)="toggleSelected(row)"
               [attr.aria-label]="row.searchText"
               [attr.test-id]="'fieldReviewCheckbox-' + row.token"
               [checked]="row.selected"
               type="checkbox"/>
      </label>
      <button (click)="locate.emit(row.searchText)"
              [attr.test-id]="'fieldReviewLocate-' + row.token"
              [title]="'TEMPLATE.ai_review_locate' | translate"
              class="btn btn-link field-review-token"
              type="button">{{ row.searchText }}</button>
      <span *ngIf="row.occurrences > 1" class="field-review-count">&times;{{ row.occurrences }}</span>
      <span *ngIf="badgeKey(row)"
            [attr.test-id]="'fieldReviewBadge-' + row.token"
            [ngClass]="'field-review-badge--' + statusClass(row)"
            class="field-review-badge">{{ badgeKey(row) | translate }}</span>
    </div>

    <div *ngIf="row.fields.length; else unmatched" class="field-review-fields">
      <span *ngFor="let field of row.fields"
            [attr.test-id]="'fieldReviewField-' + row.token + '-' + field.fieldName"
            class="field-review-field">
        {{ field.displayPath }}
        <button (click)="removeField(row, field.fieldName)"
                [attr.aria-label]="'TEMPLATE.ai_review_remove_field' | translate"
                [attr.test-id]="'fieldReviewRemove-' + row.token + '-' + field.fieldName"
                class="btn btn-icon btn-xs field-review-remove"
                type="button">
          <em aria-hidden="true" class="fa fa-light fa-times"></em>
        </button>
      </span>
    </div>
    <ng-template #unmatched>
      <div [attr.test-id]="'fieldReviewReason-' + row.token" class="text-sm text-muted">
        {{ reasonKey(row) | translate }}
      </div>
    </ng-template>

    <button (click)="togglePicker(row)"
            [attr.test-id]="'fieldReviewPick-' + row.token"
            class="btn btn-sm btn-outline b-primary text-primary field-review-pick"
            type="button">
      <em aria-hidden="true" class="fa fa-light fa-plus m-r-xs"></em>
      {{ (row.fields.length ? 'TEMPLATE.ai_review_add' : 'TEMPLATE.ai_review_assign') | translate }}
    </button>
    <gp-tree-select *ngIf="pickingToken === row.token"
                    (elementSelected)="onFieldPicked(row, $event)"
                    [attr.test-id]="'fieldReviewPicker-' + row.token"
                    [expandRoots]="false"
                    [isSorted]="true"
                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                    [tree]="fieldTree"
                    class="form-control">
    </gp-tree-select>
  </li>
</ul>
